import React, { useCallback, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { compose } from "redux";
import PropTypes from "prop-types";
import WarrantyDataCard from "./WarrantyDataCard";
import { loadWarrantiesSummary } from "../actionCreators";
import { getWarrantiesSummary, getWarrantySummaryFlags } from "../selectors";

const WarrantyDataContainer = ({
  warrantiesSummary,
  documentId,
  siteId,
  loadedSummary,
  folderOffer,
  openFolderOffer
}) => {
  const [localWarrantiesSummary, setLocalWarrantiesSummary] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const dispatch = useDispatch();

  const toggleExpanded = useCallback(() => {
    setExpanded(!expanded);
  }, [expanded]);

  useEffect(() => {
    if (!loadedSummary) dispatch(loadWarrantiesSummary(documentId, siteId));
  }, [documentId, siteId, loadedSummary, dispatch]);

  useEffect(() => {
    setLocalWarrantiesSummary(warrantiesSummary);
  }, [warrantiesSummary]);

  return (
    <WarrantyDataCard
      documentId={documentId}
      siteId={siteId}
      warrantiesSummary={localWarrantiesSummary}
      toggleExpanded={toggleExpanded}
      expanded={expanded}
      folderOffer={folderOffer}
      openFolderOffer={openFolderOffer}
    />
  );
};

WarrantyDataContainer.propTypes = {
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired,
  warrantiesSummary: PropTypes.array,
  loadedSummary: PropTypes.bool.isRequired,

  folderOffer: PropTypes.object,
  openFolderOffer: PropTypes.func
};

function mapStateToProps(state, route) {
  const key = `${route.documentId}-${route.siteId}`;
  const { loaded: loadedSummary } = getWarrantySummaryFlags(
    state.document.warrantyData.warrantySummary,
    state.entities.warrantiesSummary,
    key
  );
  return {
    loadedSummary,
    warrantiesSummary: getWarrantiesSummary(
      state.document.warrantyData.warrantySummary,
      state.entities.warrantiesSummary,
      key
    )
  };
}

export default compose(connect(mapStateToProps))(WarrantyDataContainer);
